<section
  class="services-section py-5 d-flex flex-column align-items-center justify-content-start gap-4"
>
  <h2 class="fs-3-text fw-semibold text-center h2-text px-1">
    Perval.fr, la base de données de référence des ventes immobilières
  </h2>
  <div class="w-80 row g-3 justify-content-center align-items-center">
    <app-card
      class="col-12 col-md-6 col-xl-3 d-flex justify-content-center"
      iconUrl="assets/perval-icons/main_check.svg"
      title="Fiabilité"
      secondDescription="Mise à disposition « brute » des données à l'acte"
      level="primary"
    >
      <ng-container firstDescription>
        <p class="m-0">
          50 experts qualifient les informations avec des méthodes automatisées
          pour assurer la qualité des données.
        </p>
      </ng-container>
    </app-card>
    <app-card
      class="col-12 col-md-6 col-xl-3 d-flex justify-content-center"
      iconUrl="assets/perval-icons/actualisation.svg"
      title="Fraîcheur des données"
      firstDescription=""
      secondDescription="Des références disponibles en moyenne 6 à 12 mois après date de mutation"
      level="secondary"
    >
      <ng-container firstDescription>
        <p class="m-0">Mise à jour hebdomadaire.</p>
        <p>Des références en ligne dès 6 semaines après la date de mutation.</p>
      </ng-container>
    </app-card>
    <app-card
      class="col-12 col-md-6 col-xl-3 d-flex justify-content-center"
      iconUrl="assets/perval-icons/cible.svg"
      title="Précision"
      secondDescription="3 champs descriptifs seulement pour le type Maison"
      level="tertiary"
      [mediumWidth]="true"
    >
      <ng-container firstDescription>
        <p class="m-0">8 types de biens.</p>
        <p>Jusqu'à 30 champs descriptifs par type de bien.</p>
      </ng-container>
    </app-card>
    <app-card
      class="col-12 col-md-6 col-xl-3 d-flex justify-content-center"
      iconUrl="assets/perval-icons/pouce.svg"
      title="Facilité d'utilisation"
      secondDescription="Export en fichier .csv peu lisible"
      level="quaternary"
      [smallWidth]="true"
    >
      <ng-container firstDescription>
        <p class="m-0">Listes comportant jusqu'à 30 références.</p>
        <p>Évaluation et rapports en ligne.</p>
      </ng-container>
    </app-card>
  </div>
</section>
